import { render, staticRenderFns } from "./recommendationSlider.vue?vue&type=template&id=07822cc0"
import script from "./recommendationSlider.vue?vue&type=script&lang=js"
export * from "./recommendationSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports